module.exports = __webpack_public_path__ + "media/packs/tv-6fd76783e8982d57c18d536c074478be.svg";